export default "__VITE_ASSET__DmxwSEsV__"